import clsx from 'clsx'
import type { ClassValue } from 'clsx'

/** Conditional className helper. Kept as its own module so every component
 *  imports the same one and swapping in tailwind-merge later is a one-liner. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
